import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Idioma } from 'src/app/interfaces/idioma';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdiomaService {

  private baseApiUrl = environment.baseApi + '/privado/idioma';

  constructor(private httpClient: HttpClient) { }

  async obtenerIdiomasPorIdCandidato(idCandidato: number){
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/${idCandidato}`).toPromise();
  }

  registrarIdioma(idCandidato:number, body: Idioma): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<Response>(`${this.baseApiUrl}/${idCandidato}`, body, { headers });
  }

  actualizarIdioma(body: Idioma): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put<Response>(`${this.baseApiUrl}`, body, { headers });
  }

  eliminarIdiomaPorId(idCandidato: number, idIdioma: number): Observable<Response> {
    return this.httpClient.delete<Response>(`${this.baseApiUrl}/${idCandidato}/${idIdioma}`);
  }
}
